import { render, staticRenderFns } from "./ActivatePopup.vue?vue&type=template&id=634c0988"
import script from "./ActivatePopup.vue?vue&type=script&lang=js"
export * from "./ActivatePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports